<template>
  <div class="main-wrapper" :class="[sidebarIsOpen, `${getThemeColor}-theme`]">
    <app-sidebar/>
    <app-header/>
    <div class="auth-wrapper">
      <slot/>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/sidebar/Sidebar'
import Header from '../components/header/Header'
export default {
  name: 'auth',
  components: {
    'app-sidebar': Sidebar,
    'app-header': Header
  },
  computed: {
    sidebarIsOpen () {
      return {
        'sidebar-open': this.$store.state.sidebar.sidebarOpen
      }
    },
    userIsLogged () {
      return this.$store.state.auth.authtoken
    },
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor === '0' ? 'dark' : 'light'
    },
    getAccountParams () {
      return this.$store.state.auth.accountParams
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/auth.vue